// application
import enMessages from './messages/en.json';
import ruMessages from './messages/ru.json';
import hyMessages from './messages/hy.json';

export default {
    en: {
        messages: enMessages,
        direction: 'ltr',
    },
    ru: {
        messages: ruMessages,
        direction: 'ltr',
    },
    hy: {
        messages: hyMessages,
        direction: 'ltr',
    }
};
